/* Desktop tabs progressively enhance native mobile disclosures. */
if (!customElements.get('pp-plant-information')) {
  customElements.define('pp-plant-information', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.topics = Array.from(this.querySelectorAll(':scope > .pp-info-topic'));
      this.tablist = this.querySelector('.pp-info-tabs');
      if (!this.topics.length || !this.tablist) return;
      this.active = 0;
      this.tabs = this.topics.map((topic, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.id = `${topic.id}-tab`;
        button.textContent = topic.querySelector('summary > span').textContent;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', topic.id);
        button.addEventListener('click', () => this.select(index), options);
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.select(next);
          this.tabs[next].focus();
        }, options);
        return button;
      });
      this.tablist.replaceChildren(...this.tabs);
      this.media = window.matchMedia('(min-width: 768px)');
      this.media.addEventListener('change', () => this.setMode(), options);
      this.topics.forEach((topic, index) => {
        topic.addEventListener('toggle', () => {
          if (this.media.matches || !topic.open) return;
          this.active = index;
          this.topics.forEach(other => {
            if (other !== topic && other.open) other.open = false;
          });
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.topics.findIndex(topic => topic.contains(event.target));
        if (index < 0) return;
        if (this.media.matches) this.select(index);
        else this.topics[index].open = true;
      }, options);
      this.setMode();
    }
    setMode() {
      const desktop = this.media.matches;
      const focusedTab = this.tabs.includes(document.activeElement);
      const focusedTopic = this.topics.findIndex(topic => topic.contains(document.activeElement));
      this.toggleAttribute('data-tabs', desktop);
      this.tablist.hidden = !desktop;
      this.topics.forEach(topic => {
        if (desktop) {
          topic.setAttribute('role', 'tabpanel');
          topic.setAttribute('aria-labelledby', `${topic.id}-tab`);
          topic.setAttribute('tabindex', '0');
        } else {
          topic.hidden = false;
          topic.open = false;
          topic.removeAttribute('role');
          topic.removeAttribute('aria-labelledby');
          topic.removeAttribute('tabindex');
        }
      });
      if (desktop) {
        if (focusedTopic >= 0) this.active = focusedTopic;
        this.select(this.active);
        if (focusedTopic >= 0) this.tabs[this.active].focus();
      } else if (focusedTab) this.topics[this.active].querySelector('summary').focus();
    }
    select(index) {
      this.active = index;
      this.topics.forEach((topic, i) => {
        topic.hidden = i !== index;
        topic.open = i === index;
        this.tabs[i].setAttribute('aria-selected', String(i === index));
        this.tabs[i].tabIndex = i === index ? 0 : -1;
      });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
